module.exports = __webpack_public_path__ + "static/img/cloudDoc.27f1fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/logo/cloudDoc.png
// module id = 1481
// module chunks = 2